import { useAppContext } from '../../context/AppContext';
import { ASSETS } from '../../const/assets';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Earth3D from '../Earth3D';
import RotatingText from '../RotatingText';
import { useEffect, useState } from 'react';
const ROLES = ['CEO', 'HRM', 'CMO'];
function RoleScreen() {
  const navigate = useNavigate();
  const { setSelectedRole, selectedRole } = useAppContext();
  const [searchParams] = useSearchParams();
  const isKey = searchParams.get('key') || '';

  const handleContinue = (role: string) => {
    setSelectedRole(role);
    if (isKey) {
      navigate(`/chat?role=${role}&isNewsLatest=true&key=${isKey}`);
    } else {
      navigate(`/chat?role=${role}&isNewsLatest=true`);
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div>
      <img
        className="w-screen hidden md:block md:absolute left-0 top-0 md:h-screen object-cover"
        src={ASSETS.bg1}
        alt="bsm"
      />
      <div className="w-screen absolute left-0 top-0 md:h-screen object-cover md:flex items-center md:pl-[11%] qxl:!pl-[12%] 2qxl:!pl-[15%] overflow-hidden">
        <div className="relative md:w-[500px] md:h-[500px] w-full h-[800px]">
          <div className="absolute top-0 left-0 w-full h-full z-10 flex justify-center mt-10 md:block md:mt-0">
            <Earth3D
              textureUrl={ASSETS.earth1}
              size={isMobile ? 300 : 500}
              rotationSpeed={0.005}
            />
          </div>
          <div className="absolute top-0 left-0 w-full h-full z-0 flex justify-center mt-10 md:block md:mt-0">
            <RotatingText
              text="TUẦN SAN CÔNG NGHỆ SỐ AI EXEVUTIVE BRIEF"
              radius={isMobile ? 180 : 280}
              speed={0.5}
              count={3}
              earthSize={isMobile ? 300 : 500}
              direction="counterclockwise"
              textColor="#152C92"
              charSpacing={2.8}
              fontSize={isMobile ? '0.8rem' : '1rem'}
            />
          </div>
          <div className="absolute top-0 left-0 w-full h-full flex justify-center mt-10 md:block md:mt-0">
            <RotatingText
              text="BSMLABS"
              radius={isMobile ? 220 : 310}
              speed={0.5}
              count={isMobile ? 10 : 14}
              earthSize={isMobile ? 300 : 500}
              direction="clockwise"
              textColor="#8FB2EF"
              charSpacing={isMobile ? 4 : 2.8}
              fontSize="1.2rem"
            />
          </div>
          <div className="absolute top-0 left-0 w-full h-full flex justify-center mt-10 md:block md:mt-0">
            <RotatingText
              text="TUẦN SAN CÔNG NGHỆ SỐ AI EXEVUTIVE BRIEF"
              radius={isMobile ? 260 : 340}
              speed={0.5}
              count={isMobile ? 3 : 4}
              earthSize={isMobile ? 300 : 500}
              direction="counterclockwise"
              textColor="#4983FB"
              charSpacing={isMobile ? 2.8 : 2}
              fontSize="1.2rem"
            />
          </div>
          <div className="absolute top-0 left-0 w-full h-full flex justify-center mt-10 md:block md:mt-0">
            <RotatingText
              text="BSMLABS"
              radius={isMobile ? 300 : 370}
              speed={0.5}
              count={isMobile ? 15 : 18}
              earthSize={isMobile ? 300 : 500}
              direction="clockwise"
              textColor="#2F62E1"
              charSpacing={2}
              fontSize="1.2rem"
            />
          </div>
          <div className="absolute top-0 left-0 w-full h-full flex justify-center mt-10 md:block md:mt-0">
            <RotatingText
              text="TUẦN SAN CÔNG NGHỆ SỐ AI EXEVUTIVE BRIEF"
              radius={isMobile ? 340 : 400}
              speed={0.5}
              count={4}
              earthSize={isMobile ? 300 : 500}
              direction="counterclockwise"
              textColor="#2E64E6"
              charSpacing={2}
              fontSize="1.2rem"
            />
          </div>
          <div className="absolute top-0 left-0 w-full h-full flex justify-center mt-10 md:block md:mt-0">
            <RotatingText
              text="BSMLABS"
              radius={isMobile ? 380 : 430}
              speed={0.5}
              count={isMobile ? 18 : 18}
              earthSize={isMobile ? 300 : 500}
              direction="clockwise"
              textColor="#2655DA"
              charSpacing={2}
              fontSize="1.2rem"
            />
          </div>
        </div>
      </div>
      <div className="relative z-10 md:absolute md:right-28 pt-90 md:p-4 md:h-screen h-full flex items-center justify-center flex-col">
        <div className="text-xl mb-5 md:mb-10 text-white">
          Chọn vai trò của bạn
        </div>
        <div className="flex flex-col gap-5">
          {ROLES.map((role) => (
            <div
              key={role}
              className={`rounded-2xl p-4 max-w-full w-[300px] md:w-400 cursor-pointer flex items-center justify-center ${
                selectedRole === role ? 'bg-avcs' : 'bg-white'
              }`}
              onClick={() => handleContinue(role)}
            >
              <p
                className={`text-4xl font-semibold ${
                  selectedRole === role ? 'text-white' : 'text-avcs'
                }`}
              >
                {role}
              </p>
            </div>
          ))}
        </div>
        <div className="mt-10 text-white text-xl text-center px-10 md:px-0">
          Bản tin AI hàng tuần cho các lãnh đạo doanh nghiệp, kết hợp giữa{' '}
          <br className="hidden md:block" />
          bản in và trải nghiệm kỹ thuật số tương tác với AI Chatbot.
        </div>
      </div>
    </div>
  );
}

export default RoleScreen;
